"use strict";

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.assign");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var colors_1 = require("../colors");

var light_1 = require("./light");

var primary = {
  "default": colors_1.colors.solid.caribbeanGreen,
  fill: colors_1.colors.fill.solid,
  background: {
    background: colors_1.colors.fill.solid,
    backgroundSize: "100% 100%",
    backgroundColor: colors_1.colors.solid.caribbeanGreen
  },
  text: {
    color: colors_1.colors.solid.caribbeanGreen,
    backgroundImage: colors_1.colors.fill.solid,
    backgroundSize: "100% 100%",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent"
  }
};
var text = {
  link: colors_1.colors.solid.caribbeanGreen
};
var common = {
  palette: __assign({
    primary: primary,
    text: text
  }, light_1["default"].palette)
};
exports["default"] = common;